import actionTypes from '../actionTypes';

const initialState = {
  isConnected: false,
  isMinimize: false,
  onCall: false,
  isWidgetOpen: false,
  isDuplicatePage: false,
  isDuplicateProcess: false,
  breakList: [],
  custInfo: {},
  selectedTab: 'online',
  phoneType: '', // pstn or web
  state: {},
  userBalance: 0.0

};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GLOBAL_SOCKET_STATE:
      newState.isConnected = action.payload.isConnected;
      return newState;
    case actionTypes.GLOBAL_MINIMIZE_APP:
      newState.isMinimize = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_DYNAMIC_UPDATE:
      if (action.payload.data) {
        newState[action.payload.data.key] = action.payload.data.value;
        // console.log("Dyna")
      }
      return newState;
    case actionTypes.GLOBAL_CALL_STATE:
      newState.onCall = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_TAB_STATE:
      newState.selectedTab = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_STATE:
      newState.state = action.payload.data;
      return newState;
    case actionTypes.SET_BREAK_LIST:
      console.log("SET_BREAK_LIST", action.payload.data, newState)
      newState.breakList = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_BALANCE_UPDATE:
      newState.userBalance = action.payload.data;
      return newState;


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/globalState.reducer.js